import createCrudApi from "@/app/services/baseApi";
const itensApi = createCrudApi('itens');

const axios = itensApi.axios;

export default itensApi;
